import _ from 'underscore';
import * as types from '../actions/actionTypes';
import serverApi from '../serverApi';
import { asyncActionCreator } from './asyncActionCreatorFactory';
import permissionLevel from '../permissionLevel';
import allowedScopes from '../authzScopes';

export function fetchPermissions() {
    return asyncActionCreator(types.PERMISSIONS_UPDATED, serverApi.fetchPermissions(), json => json);
}

export function updatePermissions(updateRequest) {
    let request;
    if(updateRequest.permissionLevel === permissionLevel.everyone) {
        request = {
            groupScopes: []
        };
    } else {
        request = {
            groupScopes: [{
                groupName: updateRequest.groupName,
                scopes: _(allowedScopes).values()
            }]
        };
    }

    return asyncActionCreator(types.PERMISSIONS_CHANGE_UPDATED, serverApi.updatePermissions(request), json => json);
}



// WEBPACK FOOTER //
// ./src/js/actions/permissionsActionCreators.js